<div [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label>{{ formControl.displayText }}</mat-label>
    <input
      [formControlName]="formControl.name"
      matInput
      [type]="controlType"
      [attr.step]="isInteger ? 1 : null"
      (keydown)="onKeydown($event)"
      (beforeinput)="onBeforeInput($event)"
      (paste)="onPaste($event)"
    />
    @if (integerError()) {
      <mat-error>
        {{ formControl.displayText }}
        <span i18n="@@integerOnly">must be a whole number</span>
      </mat-error>
    }
  </mat-form-field>
  <atlas-dynamic-form-validation
    [formGroup]="formGroup"
    [control]="formControl"
  >
  </atlas-dynamic-form-validation>
</div>
